import { render, staticRenderFns } from "./money-circle.vue?vue&type=template&id=831e9d6a&scoped=true"
var script = {}
import style0 from "./money-circle.vue?vue&type=style&index=0&id=831e9d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831e9d6a",
  null
  
)

export default component.exports